// Redux Reducers
import {
  INIT_CART_ID,
  INIT_CART_COUNTER,
  SET_CART_COUNTER,
  SET_CART_ITEMS,
  ADD_CART_ITEMS,
  REMOVE_CART_ITEMS,
} from "../types";

const initialState = {
  cartID: null,
  cartCounter: null,
  cartItems: []
};

function cartReducer(state = initialState, action) {

  if (action.type === INIT_CART_ID) {
    return { ...state, cartID: action.payload}
  }

  if (action.type === INIT_CART_COUNTER) {
    return { ...state, cartCounter: action.payload}
  }

  if (action.type === SET_CART_COUNTER) {
    let cartCounter = state.cartCounter + action.payload;
    cartCounter = (cartCounter < 0) ? 0 : cartCounter;
    return { ...state, cartCounter}
  }

  if (action.type === SET_CART_ITEMS) {
    return { ...state, cartItems: action.payload}
  }

  if (action.type === ADD_CART_ITEMS) {
    return { ...state, cartItems: [...state.cartItems, action.payload]}
  }

  if (action.type === REMOVE_CART_ITEMS) {
    const index = state.cartItems.findIndex( id => id === action.payload );
    let removed = [...state.cartItems];
    if (index >= 0) {
      removed.splice(index, 1);
    }
    return { ...state, cartItems: removed}
  }

  return state;
};

export default cartReducer;
